<template>
  <b-sidebar
    id="add-new-standing-order-type-sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ standingOrderTypeData.id ? 'Update' : 'Add New' }} Type
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="
            resetForm();
            hide();
          "
        />
      </div>

      <validation-observer ref="newStandingOrderTypeForm">
        <b-form
          class="p-2"
          @submit.prevent="validationForm()"
        >
          <b-form-group
            label="Name"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="Name"
              rules="required"
            >
              <b-form-input
                id="name"
                v-model="standingOrderType.name"
                :state="errors.length > 0 ? false : null"
                name="name"
                placeholder="Name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div class="d-flex mt-2">
            <b-button
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isLoading"
            >
              <b-spinner
                v-if="isLoading"
                small
                variant="light"
              />
              {{ standingOrderTypeData.id ? 'Update' : 'Add' }}
            </b-button>
            <b-button
              type="button"
              variant="outline-secondary"
              @click="
                resetForm();
                hide();
              "
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSidebar,
  BSpinner,
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import useStandingOrderType from '@/modules/standing-order-type/composables/useStandingOrderType';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    standingOrderType: {
      type: Object,
      require: true,
    },
  },
  setup(props, ctx) {
    const { createStandingOrderType, editStandingOrderType } =
      useStandingOrderType();

    const newStandingOrderTypeForm = ref(null);
    const standingOrderTypeData = ref(props.standingOrderType);
    const isLoading = ref(false);

    const resetForm = () => {
      newStandingOrderTypeForm.value.reset();
    };

    const validationForm = async () => {
      if (isLoading.value) return;

      isLoading.value = true;

      const valid = await newStandingOrderTypeForm.value.validate();
      if (!valid) {
        isLoading.value = false;
        return;
      }

      standingOrderTypeData.value.id
        ? await editStandingOrderType(standingOrderTypeData.value)
        : await createStandingOrderType(standingOrderTypeData.value);

      ctx.emit('form-submitted');

      isLoading.value = false;
    };

    return {
      // Reactive
      newStandingOrderTypeForm,
      standingOrderTypeData,
      isLoading,

      // Method
      resetForm,
      validationForm,

      // Validator
      required,
    };
  },
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSidebar,
    ValidationObserver,
    ValidationProvider,
    BSpinner,
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-standing-order-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
